import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgEnvelopeIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="envelope_svg__nc-icon-wrapper">
      <path d="M12.5 17.9c-.2.1-.3.1-.5.1s-.3 0-.5-.1L0 11.7V23c0 .6.4 1 1 1h22c.6 0 1-.4 1-1V11.7l-11.5 6.2z" />
      <path d="M6 12.6V2h12v10.6l5.1-2.8L20 7.5V1c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v6.6L.9 9.9 6 12.6z" />
      <path data-color="color-2" d="M8 5h8v2H8zM8 9h8v2H8z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgEnvelopeStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgEnvelopeIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const EnvelopeIcon: any = SvgEnvelopeStyle;
export default EnvelopeIcon;
